/*
 * Author: Harper Yan
 * File Created:   dnesday, 24-07-10 02:50 pm  * Last Modified: Wednesday, 24-07-10 02:50 pm, by Harper Yan
 */

import { memo } from 'react';
import { SnackbarContent } from '@mui/material';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { useSnackbarStore } from './useSnackbarStore';

/**
 * At most one snackbar can appear at a time. New snackbar will replace existed snackbar if have any.
 * @returns Snackbar
 */
const GlobalSnackbar = () => {
  const {
    snackbarProps,
    hide
  } = useSnackbarStore(state => ({
    snackbarProps: state.snackbarProps,
    hide: state.hide
  }));
  if (!snackbarProps) {
    return;
  }
  const handleClose = (event: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => {
    if (snackbarProps?.onClose) {
      snackbarProps.onClose(event, reason);
    } else {
      hide();
    }
  };
  const {
    style,
    ...rest
  } = snackbarProps;
  return <Snackbar autoHideDuration={1500} open={snackbarProps?.open || false} onClose={handleClose} style={{
    width: 'max-content',
    ...snackbarProps.style
  }} {...snackbarProps} data-sentry-element="Snackbar" data-sentry-component="GlobalSnackbar" data-sentry-source-file="index.tsx"></Snackbar>;
};
export default memo(GlobalSnackbar);